/* eslint-disable  camelcase */
export enum VF_NAMING_MAP {
    bingo_bonus = 'Bingo Bonus',
    games_bonus = 'All Games Bonus'
}

export enum BALANCE_TYPES {
    bonus_balance = 'bonus_balance',
    total_bonus_balance = 'total_bonus_balance',
    real_gaming_balance = 'real_gaming_balance',
    free_spin_balance = 'free_spin_balance',
    withdrawable_balance = 'withdrawable_balance',
    casino_gaming_balance = 'casino_gaming_balance',
    bonus_pending_winnings = 'bonus_pending_winnings',
    ringfenced_real_balance = 'ringfenced_real_balance',
    broken_games_real_balance = 'broken_games_real_balance',
    casino_table_real_balance = 'casino_table_real_balance',
    broken_games_bonus_balance = 'broken_games_bonus_balance',
    total_balance = 'total_balance',
    retail_gaming_balance_by_context = 'retail_gaming_balance_by_context'
}

export const DEFAULT_BALANCE_MAP = [
    BALANCE_TYPES.casino_gaming_balance,
    BALANCE_TYPES.total_balance,
    VF_NAMING_MAP.games_bonus,
    BALANCE_TYPES.withdrawable_balance,
    BALANCE_TYPES.retail_gaming_balance_by_context,
    BALANCE_TYPES.total_bonus_balance,
    VF_NAMING_MAP.bingo_bonus
];
